import { 
  useEffect, useMemo, useRef, useState
} from 'react';
import useSWR from 'swr';

import fetchAssays from '../../utils/api_functions/assayListRequest';
import { getTimeRange } from '../../utils/date_utils';
import { mapAssayDetails } from '../../utils/assay_utils';

export const useAssayList = ({
  pipelineID,
  workspaceID,
  assayFilter,
  validationDelay = 500,
}) => {
  const errorTimeoutRef = useRef(null);

  const [isLoading, setLoading] = useState(false);
  const [errorMessage, setError] = useState(null);

  const [currentData, setCurrentData] = useState([]);

  const dateObj = useMemo(() => {
    if (assayFilter?.timeRange?.duration) {
      const [timeRangeStartDate, timeRangeEndDate] = getTimeRange(assayFilter.timeRange);
      return { start: timeRangeStartDate, end: timeRangeEndDate };
    }
    return { start: assayFilter?.start, end: assayFilter?.end };
  }, [assayFilter])
  
  const {
    data,
    error,
    mutate,
  } = useSWR([pipelineID, workspaceID, assayFilter, dateObj?.start ? dateObj : undefined, 'assay-list'], fetchAssays, {
    refreshInterval: 3000,
    loadingTimeout: validationDelay,
    onLoadingSlow: () => setLoading(true),
    onSuccess: () => setLoading(false),
    onError: () => setLoading(false),
  });

  useEffect(() => {
    if (data) {
      setCurrentData(data?.map(mapAssayDetails));
    }
  }, [data])

  useEffect(() => {
    if (error) {
      errorTimeoutRef.current = setTimeout(() => {
        setError(error?.message || error?.msg);
      }, validationDelay);
    } else {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }

    return () => {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }
  }, [error, validationDelay]);

  return {
    data: currentData,
    error: errorMessage,
    isLoading,
    refetchAssays: mutate,
  };
}

export default useAssayList;
